import { defaultConfig, defineKeyframes } from '@chakra-ui/react';

import { colors } from './tokens/colors';

const keyframes = defineKeyframes({
    ...defaultConfig.theme?.keyframes,
    scroll: {
        '0%': { transform: 'translateX(0)' },
        '100%': { transform: 'translateX(-50%)' },
    },
    flashSuccess: {
        '0%': { backgroundColor: 'transparent' },
        '25%': { backgroundColor: colors.green[100].value },
        '100%': { backgroundColor: 'transparent' },
    },
    flashDanger: {
        '0%': { backgroundColor: 'transparent' },
        '25%': { backgroundColor: colors.red[100].value },
        '100%': { backgroundColor: 'transparent' },
    },
});

export { keyframes };
